import { render, staticRenderFns } from "./NewAccountSummary.vue?vue&type=template&id=5666c9d6&scoped=true&"
import script from "./NewAccountSummary.vue?vue&type=script&lang=js&"
export * from "./NewAccountSummary.vue?vue&type=script&lang=js&"
import style0 from "./NewAccountSummary.vue?vue&type=style&index=0&id=5666c9d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5666c9d6",
  null
  
)

export default component.exports